import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { LayoutService } from 'libs/portal/src/layout/layout.service';
import { Endpoints } from '@huge-monorepo/portal/config';
import { RefreshData } from '../../tools/card-table/models/generic-table-header-options.model';
import { openExportDialog } from '../../tools/export-modal/export-modal.component';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { UntypedFormControl } from '@angular/forms';
import { ToolsService } from '@huge-monorepo/portal/services';
import * as _moment from 'moment';
import { Location } from '@angular/common';
import { CustomDateAdapter, CUSTOM_DATE_FORMATS } from 'libs/portal/src/modules/tools/card-table/components/custom-date-adapter';

const moment = _moment;

@Component({
  selector: 'app-keep-alive-tls-device-report',
  templateUrl: './keep-alive-tls-device-report.component.html',
  styleUrls: ['./keep-alive-tls-device-report.component.scss'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },
    { provide: DateAdapter, useClass: CustomDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMATS },
  ],
})
export class KeepAliveTLSDeviceReportComponent implements OnInit {
  date = new Date();
  startDate = new UntypedFormControl(new Date(this.date.getFullYear(), this.date.getMonth(), 1));
  endDate = new UntypedFormControl(this.date);

  downloading = false;

  constructor(
    public layoutService: LayoutService,
    private endpoints: Endpoints,
    private dialogRef: MatDialog,
    private tools: ToolsService,
    private _location: Location,
  ) {}

  ngOnInit() {

  }

  exportReport(): void {
    openExportDialog(this.dialogRef, {
      endpoint: this.endpoints.DOWNLOAD_KEEP_ALIVE_TLS_DEVICE_REPORT,
      reqObj: {
        StartDate: this.tools.FormatStartDate(this.startDate.value.toISOString()),
        EndDate: this.tools.FormatEndDate(this.endDate.value.toISOString())
      },
    });
  }

  cancel() {
    this._location.back();
  }
}
